import React, { useState } from 'react';
import styles from './ContactPage.module.css';
import MessageBox from '../../components/MessageBox';

const ContactPage = () => {
  const [message, setMessage] = useState(null);

  const handleCloseMessage = () => {
    setMessage(null);
  };

  return (
    <div className={styles['contact-container']}>
      {message && <MessageBox message={message.text} type={message.type} onClose={handleCloseMessage} />}
      <h2>Contact Support</h2>
      <p>If you have any questions or need assistance, please feel free to contact us.</p>
      <div className={styles['contact-details']}>
        <p><strong>Email:</strong> support@{(process.env.REACT_APP_NAME || '').toLowerCase()}.com</p>
        <p><strong>Phone:</strong> +1 (800) 123-4567</p>
      </div>
    </div>
  );
};

export default ContactPage;
